import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        /* -- Multiple approaches to ensure scroll -- */
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
        document.body.scrollTop = 0                                     // For Safari
        document.documentElement.scrollTop = 0                          // For Chrome, Firefox, IE and Opera
        
        /* -- Also setting it on the next tick -- */
        setTimeout(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
        }, 0)
    }, [pathname])

    return null
}

export default ScrollToTop;